import React from "react";
import { Form, Button, Col } from "react-bootstrap";

export function Rows({
  isDelete,
  onChange,
  onRemove,
  ingrediente,
  productos,
  cantidad,
  mod,
}) {
  return (
    <>
      <Col md={5}>
        <Form.Group controlId="ingrediente" className="center">
          Ingrediente
          <select
            disabled={isDelete}
            value={ingrediente}
            onChange={(e) => onChange("ingrediente", e.target.value)}
          >
            <option value="">Seleccionar</option>
            {productos != null
              ? productos.map((opcion) => (
                  <option key={opcion.id} value={opcion.id}>
                    {opcion.Nombre}
                  </option>
                ))
              : ""}
          </select>
        </Form.Group>
      </Col>
      <Col md={5}>
        <div className="center">
          <Form.Group controlId="Cantidad">
            Cantidad
            <Form.Control
              disabled={isDelete}
              onChange={(e) => onChange("cantidad", e.target.value)}
              type="number"
              value={cantidad}
              min={0}
            />
          </Form.Group>
        </div>
      </Col>
      <Col md={2}>
        <div className="center">
          {mod !== "DLT" ? <Button onClick={onRemove}>Eliminar</Button> : ""}
        </div>
      </Col>
    </>
  );
}
